import { store } from '../../store';

export function relationshipNameFromId(roleId) {
  const caseRoles = store.getState().entities.metaData.caseRoles;

  const roles = caseRoles.filter(r => r.id === roleId);
  if (roles && roles.length > 0) return roles[0].name;
  else return '';
}
